<script lang="ts">
  export let title = '';
  export let subtitle = '';
</script>

<div class="page-inner">
  <div class="page-header d-flex justify-space-between" class:has-header={$$slots.header}>
    <div>
      <h3 class="text-h5">
        {title}
        {#if subtitle}
          <span class="subtitle">
            {subtitle}
          </span>
        {/if}
      </h3>
    </div>
    <div class="page-actions">
      <slot name="actions" />
    </div>
  </div>
  <div class="page-view" class:has-header={$$slots.header}>
    {#if $$slots.sidebar}
      <div class="page-sidebar">
        <slot name="sidebar" />
      </div>
    {/if}
    {#if $$slots.header}
      <div class="page-stack-header">
        <slot name="header" />
      </div>
    {/if}
    <slot />
  </div>
</div>

<style lang="scss">
  :global {
    .page-inner {
      width: 100%;
      height: 100%;
      padding-left: var(--gap);
      padding-right: var(--gap);
      padding-top: calc(var(--header-height) + calc(var(--gap) * 2));
      display: flex;
      flex-direction: column;
    }

    .page-header {
      padding: 0 var(--gap);

      &.has-header {
        display: none;
      }

      .event-actions .s-select {
        min-width: 420px;
      }
    }

    .page-view {
      flex: 1;
      padding: var(--gap);
      padding-bottom: 0;
      display: flex;
      overflow: hidden;

      &.has-header {
        flex-direction: column;
        padding: 0;

        > .scroller {
          padding: var(--gap);
        }
      }

      > .scroller {
        flex: 1;
        height: 100%;
        width: 100%;
        overflow: hidden;
      }

      .page-sidebar {
        flex: 0 0 256px;
        display: flex;
        margin-left: -4px;
        padding-top: 6px;

        [slot='sidebar'] {
          width: 100%;
        }

        .s-list-item__content {
          padding-right: 24px;
        }

        .scroller {
          flex: 1;
        }
      }
    }
  }
</style>
